import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { InputText } from "primereact/inputtext";
import { useState } from "react";

const Tabla = ({ datos }) => {
    const [filtroGlobal, setFiltroGlobal] = useState("");
    return (
        <>
            <div className="grupo-filtro mb-2">
                <label htmlFor="globalFilter">Buscar</label>
                <InputText
                    id="globalFilter"
                    value={filtroGlobal}
                    onChange={(e) => setFiltroGlobal(e.target.value)}
                    placeholder="Buscar por cualquier campo"
                    className="input_search"
                />
            </div>
            <DataTable
                value={datos}
                stripedRows
                responsiveLayout="scroll"
                scrollable
                scrollHeight="calc(100vh - 150px)"
                globalFilter={filtroGlobal}
                
            >
                <Column field="ID" header="ID" />
                <Column field="NOMBRE" header="Nombre" />
                <Column field="EMAIL" header="Correo" />
                <Column field="TELEFONO" header="Teléfono" />
                <Column field="DIAS_TRANSCURRIDOS" header="Días de Antigüedad" />
                <Column field="TIEMPO_INGRESO" header="Tiempo de Ingreso" />
            </DataTable>
        </>
    )
}
export default Tabla